module.exports = __webpack_public_path__ + "static/6ewaste-c7d7c57b37515136496abdafde46785a.png";